
import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="container py-12">
      <div className="flex justify-center">
        <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
